import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  HttpCustomOptions,
  HttpCustomService,
} from 'src/services/http-interceptor.service';

import { HttpMethod } from '../constants/constant';
import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root',
})
export class ServiceManagerService {
  email: any = '';
  private envFileUrl = 'assets/prod.json';
  constructor(
    private httpCommonService: HttpCustomService,
    public router: Router,
    private auth: AuthService,
    public httpClient: HttpClient,
    private _location: Location
  ) {
    this.getProfileEmail();
    this.httpClient.get(this.envFileUrl).subscribe((data: any) => {
      if (data['url'] != "/api/") {
        localStorage.setItem('url', data['url']);
      }
    });
  }

  public CallBackendServiceAPI(
    serviceName: string,
    body: any,
    method: string = HttpMethod.POST,
    customOptions?: HttpCustomOptions,
    authTokenRequired: boolean = true
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    if (authTokenRequired) {
      httpOptions.headers = httpOptions.headers.set(
        'Authorization',
        this.getUserAuthToken()
      );
    }
    const endpointURL = this.getBackendUrl() + serviceName;
    const defaultCustomOptions: HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: false,
      createLoaderAction: true,
    };
    switch (method) {
      case HttpMethod.GET:
        return this.httpCommonService.get(
          endpointURL,
          httpOptions,
          customOptions || defaultCustomOptions
        );
      case HttpMethod.PUT:
        return this.httpCommonService.put(
          endpointURL,
          body,
          httpOptions,
          customOptions || defaultCustomOptions
        );
      case HttpMethod.DELETE:
        console.log('Delete');
        return this.httpCommonService.delete(
          endpointURL,
          httpOptions,
          customOptions || defaultCustomOptions
        );
      default:
        return this.httpCommonService.post(
          endpointURL,
          body,
          httpOptions,
          customOptions || defaultCustomOptions
        );
    }
  }

  isFilled(inputVar: any) {
    return (
      inputVar !== undefined && inputVar !== null && inputVar.toString().trim()
    );
  }

  logoutUser() {
    localStorage.removeItem('idToken');
    this.router.navigate(['/login']);
  }

  isLoggedIn() {
    var token = localStorage.getItem('idToken') || '';
    return this.isFilled(token);
  }

  getBackendUrl() {
    var url = localStorage.getItem('url');
    if (!url || url == "/api/") {
      return environment.baseUrl + '/';
    } else {
      return environment.baseUrl + '/' + url;
    }
  }

  navigateToPageWithState(page: any, state = {}) {
    this.router.navigate([page], { state: state });
  }

  navToValidRoute() {
    let url = this.router.url.split('?')[0];
    var is_valid =
      [
        '/login',
        '/forgot-password',
        '/authenticate',
        '/reset-password',
      ].includes(url) && this.isLoggedIn();
    if (is_valid) {
      this.router.navigate(['/people']);
    }
  }

  isValidEmail(email: any) {
    var mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return Boolean(email.match(mailFormat));
  }

  private getUserAuthToken(): any {
    return localStorage.getItem('idToken');
  }

  getProfileEmail() {
    var token = this.getUserAuthToken();
    this.email = this.auth.getTokenData(token)?.email;
  }

  goBack() {
    this._location.back();
  }
}
